module.exports = __webpack_public_path__ + "img/selectedtick.719ac999.svg";